import OrderFormService from '../service';

class NewOrderFormService extends OrderFormService {}

export default new NewOrderFormService();
